import {
    Dialog,
    DialogContent,
    DialogTitle,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";

export default function SchedulePrograms({
    scheduleData,
    currentTime,
    scheduleTotalTime,
}) {
    const currentProgram = useRef(null);
    const [hasScrolled, setHasScrolled] = useState(false);
    const [isInfoPanelOpen, setIsInfoPanelOpen] = useState(false);
    const [selectedProgram, setSelectedProgram] = useState(null);

    // scroll to current program when data initially loads in
    useEffect(() => {
        currentProgram.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
        setHasScrolled(true);
    }, [scheduleData, hasScrolled]);

    const openInfoPanel = (program) => {
        setSelectedProgram(program);
        setIsInfoPanelOpen(true);
    };

    const closeInfoPanel = () => {
        setIsInfoPanelOpen(false);
    };

    return (
        <>
            <Dialog open={isInfoPanelOpen} onClose={closeInfoPanel}>
                <DialogTitle>{selectedProgram?.title}</DialogTitle>
                <DialogContent>
                    <Typography>{selectedProgram?.description}</Typography>
                    <br />
                    <Typography>
                        <b>Starts At:</b>{" "}
                        {selectedProgram?.start.toLocaleString("en-US", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                        })}
                    </Typography>
                    <Typography>
                        <b>Stops At:</b>{" "}
                        {selectedProgram?.stop.toLocaleString("en-US", {
                            year: "numeric",
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                        })}
                    </Typography>
                </DialogContent>
            </Dialog>
            <Stack
                id="SchedulePrograms"
                direction="column"
                height="100%"
                spacing={0.5}
                sx={{
                    minWidth: "11em",
                    flex: "1 1 0",
                }}
            >
                {scheduleData.map((program, index) => {
                    const isCurrent =
                        program.start <= currentTime &&
                        program.stop > currentTime;
                    return (
                        <Paper
                            onClick={() => openInfoPanel(program)}
                            ref={isCurrent ? currentProgram : null}
                            key={index}
                            elevation={5}
                            sx={{
                                height: `${
                                    ((program.stop - program.start - 60000) /
                                        scheduleTotalTime) *
                                    100
                                }%`,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: isCurrent && "primary.contrastText",
                                backgroundColor: isCurrent && "primary.main",
                                cursor: "pointer",
                            }}
                        >
                            <Typography noWrap={true}>
                                {program.title}
                            </Typography>
                        </Paper>
                    );
                })}
            </Stack>
        </>
    );
}
